module.exports = __webpack_public_path__ + "img/rob.2dde21e3.svg";